<template><div><h1>Does VUX support weex</h1>
<p>No, and not plan to support it.</p>
</div></template><script>
export default {
  head: {"title":"Does VUX support weex | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// does-vux-support-weex-13.vue?60b9561b